import { abortIfNotPermitted, abortIfRequiresSubscription } from '../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "outlet" */ '@js/franchise_component/setting/devices/device-datatable.vue'),
    },
    {
        path: '/create',
        component: () =>
            import(/* webpackChunkName: "outlet" */ '@js/franchise_component/setting/devices/device-create.vue'),
        beforeEnter: (to, from, next) => {
            abortIfRequiresSubscription('franchise_manage_devices', next);
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "outlet" */ '@js/franchise_component/setting/devices/device-update.vue'),
    },
];
